export const DOOR_VISUAL_CHANGE_VALUES = 'DOOR_VISUAL_CHANGE_VALUES'